import { SubscriptionModel } from '../../../models';
import { SubscriptionScopes } from '../../../types';

export enum SubscriptionActions {
  PAUSE = 'PAUSE',
  RESUME = 'RESUME',
  CANCEL = 'CANCEL',
  UNDO_CANCELATION = 'UNDO_CANCELATION',
  REACTIVATE = 'REACTIVATE',
  CHANGE_PLAN = 'CHANGE_PLAN',
}

export const useSubscriptionAvailableActions = (
  subscription: Partial<SubscriptionModel>,
  subscriptionScopes: SubscriptionScopes[]
) => {
  const availableActions: SubscriptionActions[] = [];
  if (
    ['active', 'plan_change_scheduled', 'past_due'].includes(
      subscription.status
    ) &&
    subscriptionScopes.includes('subscription:pause')
  ) {
    availableActions.push(SubscriptionActions.PAUSE);
  }
  if (
    'on_hold' === subscription.status &&
    subscriptionScopes.includes('subscription:resume')
  ) {
    availableActions.push(SubscriptionActions.RESUME);
  }
  if (
    !['canceled', 'past_due', 'cancellation_scheduled'].includes(
      subscription.status
    ) &&
    hasCancelDelayedOrImmediateAction(subscriptionScopes)
  ) {
    availableActions.push(SubscriptionActions.CANCEL);
  }
  if (
    subscription.status === 'cancellation_scheduled' &&
    subscriptionScopes.includes('subscription:cancel-scheduled')
  ) {
    availableActions.push(SubscriptionActions.UNDO_CANCELATION);
  }
  if (
    ['trial_expired', 'canceled'].includes(subscription.status) &&
    subscriptionScopes.includes('subscription:reactivate')
  ) {
    availableActions.push(SubscriptionActions.REACTIVATE);
  }
  if (
    ['active', 'plan_change_scheduled', 'trial'].includes(
      subscription.status
    ) &&
    subscriptionScopes.includes('subscription:plan-change')
  ) {
    availableActions.push(SubscriptionActions.CHANGE_PLAN);
  }
  return availableActions;
};

const hasCancelDelayedOrImmediateAction = (scopes: SubscriptionScopes[]) => {
  return (
    scopes.includes('subscription:cancel-delayed') ||
    scopes.includes('subscription:cancel-immediate')
  );
};
